// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"f2c9a269","453":"6405234c"}[chunkId] + ".chunk.js";
};